module.exports = __webpack_public_path__ + "static/media/tomthumb.bb32f18f.svg";